import React from "react"
import { ResponsivePie } from "@nivo/pie"
import ChartCard from "./ChartCard"
import PieLegend from "./PieLegend"
import { PROJECT_STATUS_COLORS, NIVO_THEME } from "./palette"

const CenterMetric = ({ centerX, centerY, total, label }) => (
  <g transform={`translate(${centerX}, ${centerY})`}>
    <text textAnchor="middle" dominantBaseline="central" fill="#0f172a"
          style={{ fontSize: 22, fontWeight: 700, fontFamily: "inherit" }}>
      {total.toLocaleString("fr-FR")}
    </text>
    <text textAnchor="middle" dominantBaseline="central" fill="#64748b" y={18}
          style={{ fontSize: 10, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px" }}>
      {label}
    </text>
  </g>
)

const ProjectsPieChart = ({ data }) => {
  const total = data.reduce((acc, d) => acc + d.value, 0)

  // Bake color into each datum so Nivo can pick it up safely
  const coloredData = data.map(d => ({
    ...d,
    color: PROJECT_STATUS_COLORS[d.id] || "#94a3b8",
  }))

  const legendItems = coloredData.map(d => ({
    id:    d.id,
    label: d.label,
    value: d.value,
    color: d.color,
  }))

  return (
    <ChartCard
      icon  = "hard-hat"
      title = {I18n.t("chantiers_dashboard.charts.projects_by_status")}
      empty = {total === 0 ? I18n.t("chantiers_dashboard.charts.empty") : null}
    >
      <div className="h-full flex items-center px-5 pb-4 pt-3">
        <div className="shrink-0 relative" style={{ width: 210, height: 210 }}>
          <ResponsivePie
            data                    = {coloredData}
            margin                  = {{ top: 4, right: 4, bottom: 4, left: 4 }}
            innerRadius             = {0.68}
            padAngle                = {1.5}
            cornerRadius            = {3}
            activeOuterRadiusOffset = {6}
            colors                  = {{ datum: "data.color" }}
            borderWidth             = {2}
            borderColor             = "#fff"
            enableArcLinkLabels     = {false}
            enableArcLabels         = {false}
            theme                   = {NIVO_THEME}
            layers                  = {[
              "arcs",
              "arcLabels",
              "arcLinkLabels",
              "legends",
              (props) => (
                <CenterMetric
                  centerX = {props.centerX}
                  centerY = {props.centerY}
                  total   = {total}
                  label   = {I18n.t("chantiers_dashboard.kpis.projects")}
                />
              ),
            ]}
          />
        </div>
        <div className="flex-1 self-center min-w-0 pl-3 overflow-hidden">
          <PieLegend items={legendItems} />
        </div>
      </div>
    </ChartCard>
  )
}

export default ProjectsPieChart
